import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      colAction: {
        "&:last-child": {
          paddingRight: theme.spacing(),
          textAlign: "right",
          width: 130
        }
      },
      colActionHeader: {
        textAlign: "right",
        width: 130
      },
      colName: {
        verticalAlign: "top",
        width: 220
      },
      colNameHeader: {
        width: 220
      },
      colValue: {},
      content: {
        paddingBottom: 0,
        paddingTop: theme.spacing()
      },
      emptyContainer: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(3),
        textAlign: "center"
      },
      emptyImage: {
        display: "block",
        marginBottom: theme.spacing(2)
      },
      input: {
        padding: theme.spacing(0.5, 2)
      },
      nameInput: {
        padding: `13px 16px`
      },
      table: {
        tableLayout: "fixed"
      },
      togglable: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between"
      }
    }),
  { name: "styles" }
);

export default useStyles;
